import React from "react";
import { FormattedMessage } from "react-intl";
import popupBg from "./../../../assets/popupBgGiftCard.png";

const EnrollButton = ({ link, children, onClick }) => (
  <button onClick={onClick}>
    <a
        href={link}
        className="box-border flex w-52 cursor-pointer items-center justify-center rounded-md border border-primary-blue bg-white px-6 py-1 text-base font-bold leading-7 text-primary-blue hover:text-primary-blue-hover"
        target="_blank"
        rel="noreferrer"
    >
        {children}
    </a>
  </button>
);

const BgImage = () => {
    const url = new URLSearchParams(document.location.search);
    const popupBg = url.get("card_type_image_url");

    return <img src={popupBg} alt="bg" className="absolute bottom-0 right-0 -z-10" style={{
        transform: "rotateZ(-30deg) translateX(-10px) translateY(80px)",
        width: "102px"
    }} />
};

const OfferPopup = ({onClick}) => {
  return (
    <div className="relative z-10 w-[356px] rounded-md bg-[#ECF3FF] p-5 pb-6 overflow-hidden">
      <h3 className="mb-2 text-sm font-bold text-primary-blue">
        <FormattedMessage id="giftCard.offerPopup.heading" />
      </h3>
      <p className="mb-6 text-sm">
        <FormattedMessage id="giftCard.offerPopup.text" />
      </p>
      <EnrollButton onClick={onClick} link="https://www.surveymonkey.com/r/9P9NPKJ?app_pkg=[app_pkg_value]&email=[email_value]&survey_attempt_number=[survey_attempt_number_value]&survey_id=[survey_id_value]&guid=[guid_value]&prod_ver=[prod_ver_value]&app_ver=[app_ver_value]&vm_id=[vm_id_value]&popup_type=[popup_type_value]&locale=[locale_value]">
        <FormattedMessage id="giftCard.offerPopup.buttonLink" />
      </EnrollButton>
      <BgImage />
    </div>
  );
};

export default OfferPopup;
